import React from 'react';

import { Box, FormLabel, Link, styled, Typography } from '@mui/material';

import { DynamicFormElOnChange } from '@/components/DynamicForm/types/DynamicFormTypes';

import { selectImageInputStyles, formLabelStyles, linkStyles } from './ImagePickerWithPreview.styles';

interface SelectImageInputProps {
	id?: string;
	accept?: string;
	handleOnChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
	previewUrl?: string | null;
	handleClick?: () => void;
	onChange?: DynamicFormElOnChange;
}

export default function SelectImageInput({
	id,
	accept,
	handleOnChange,
	previewUrl,
	handleClick,
	onChange,
}: Readonly<SelectImageInputProps>) {
	const VisuallyHiddenInput = styled('input')({ display: 'none' }) as unknown as 'input';

	const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		handleOnChange(e);
		onChange?.(e);
	};

	return (
		<Box data-test-id="link-label-section" className="link-label-section" sx={selectImageInputStyles}>
			{previewUrl ? (
				<FormLabel sx={formLabelStyles}>
					<Link data-test-id="replace-photo-link" underline="hover" sx={linkStyles}>
						<Typography color="inherit" variant="bodyMediumBook">
							Replace Photo
						</Typography>
						<VisuallyHiddenInput
							data-test-id="hidden-image-input"
							id={id}
							name={id}
							accept={accept ?? '.png, .jpg, .jpeg'}
							type="file"
							onChange={(e) => handleChange(e)}
							onClick={handleClick}
						/>
					</Link>
				</FormLabel>
			) : (
				<>
					<Typography
						data-test-id="drag-and-drop-instruction"
						color="text.secondary"
						variant="bodyMediumBook"
					>
						Drag &amp; Drop
					</Typography>
					<Typography color="text.tertiary" variant="bodySmallBook">
						{' '}
						or{' '}
					</Typography>
					<FormLabel sx={formLabelStyles}>
						<Link
							data-test-id="browse-files-link"
							color="text.interactive"
							underline="hover"
							sx={linkStyles}
						>
							<Typography color="inherit" variant="bodySmallBook">
								Browse files
							</Typography>
							<VisuallyHiddenInput
								data-test-id="hidden-image-input"
								id={id}
								name={id}
								accept={accept ?? '.png, .jpg, .jpeg'}
								type="file"
								onChange={(e) => handleChange(e)}
								onClick={handleClick}
							/>
						</Link>
					</FormLabel>
				</>
			)}
		</Box>
	);
}
